import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'The Session Builder gave me a consistent way to organize pediatric visits without starting from a blank page. I can quickly adapt an activity for each child, then spend more of my preparation time thinking about the family rather than rebuilding the framework.',
  author: 'Danielle Morris, OTR/L',
  role: 'Pediatric Outpatient OT, Age 34',
  location: 'Austin, TX'
}, {
  text: 'I work across a busy inpatient rehab schedule, and the progressions plus documentation tools have made my weekly workflow much more manageable. The resources give me a clear starting point while still leaving room for clinical judgment with every patient.',
  author: 'Natalie Rivera, MS, OTR/L',
  role: 'Hospital Rehabilitation OT, Age 41',
  location: 'Denver, CO'
}, {
  text: 'The Activity & Intervention Library is especially useful for the variety of sensory, fine motor, and school participation needs I see. Having ideas organized in one place helps me create purposeful sessions more efficiently for students and teachers.',
  author: 'Megan Shaw, OTR/L',
  role: 'School-Based Occupational Therapist, Age 29',
  location: 'San Diego, CA'
}, {
  text: 'As a private practice owner, I needed systems that felt polished without becoming rigid. The home program templates and clinical documentation pack help me communicate clearly with caregivers and keep my caseload organized from week to week.',
  author: 'Ashley Thompson, OTR/L',
  role: 'Private Practice Owner, Age 38',
  location: 'Tampa, FL'
}, {
  text: 'Home health requires me to be flexible and prepared in different environments every day. The ready-to-use plans and ADL-focused resources give me dependable structure that I can grade for each person’s current level of independence.',
  author: 'Jennifer Lee, OTR/L',
  role: 'Home Health Occupational Therapist, Age 46',
  location: 'Phoenix, AZ'
}];
export function Testimonials() {
  return <section className="border-y border-brand-line bg-brand-cloud px-4 py-6" data-id="element-174" data-mp="1xh7ocvgosar2">
      <div className="mx-auto max-w-4xl" data-id="element-175" data-mp="1sk7hwjfxd5zf">
        <div className="mb-4 text-center" data-id="element-176" data-mp="1sh34cvgkkxw3">
          <h2 className="mb-1 text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-177" data-mp="1og9jyc2c617y">
            WHAT YOUR FELLOW THERAPISTS ARE SAYING
          </h2>
          <p className="text-sm font-bold uppercase tracking-wide text-brand-navy" data-id="element-178" data-mp="1jkc5ycejp6yc">
            Verified reviews from Occupational Therapists
          </p>
        </div>
        <div className="space-y-2.5" data-id="element-179" data-mp="19rmwfn2k235n">
          {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm sm:p-4" data-id="element-180" data-mp="14ud6m6b97pha">
              <div className="mb-1.5 flex gap-1" aria-label="5 star customer story" data-id="element-181" data-mp="10tkw79qnbejf">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-gold text-brand-gold" data-id="element-182" data-mp="qtu2vbdtn5kx" />)}
              </div>
              <p className="mb-2.5 text-sm font-medium leading-snug text-brand-slate italic sm:text-base" data-id="element-183" data-mp="32fujpk7fadi1">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-2.5 border-t border-brand-line pt-2.5" data-id="element-184" data-mp="3cf3j4sl24kbs">
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-sage font-display text-base font-extrabold text-brand-navy" data-id="element-185" data-mp="3ggoto7a4cmit">
                  {testimonial.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-186" data-mp="2oozf4k3yiik9">
                  <p className="text-sm font-extrabold text-brand-ink" data-id="element-187" data-mp="2opr5ngip5q3o">{testimonial.author}</p>
                  <p className="text-[11px] font-bold uppercase tracking-wide text-brand-slate" data-id="element-188" data-mp="2spt7pqscgljh">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}